










































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { apiClient } from "../../api/ApiClient";
import moment from "moment";
import {
  createNotify,
  updateNotify,
  deleteNotify,
  notifyError,
  notifyErrorThrow,
  successNotify
} from "@/utils/formHelper";
import TickCross from "@/components/TickCross.vue";
import Enumerable from 'linq';
import validator from 'validator';
import { isSubscriptionValid } from '../../utils/subscriptionHelper';
import camelcase from 'camelcase';
import { baseURL } from '../../utils/request';
import { download } from '@/utils/file';

@Component({
  components: {
    TickCross,
  },
})
export default class extends Vue {

  public get moment() {
    return moment;
  }

  public get isSubscriptionValid() {
    return isSubscriptionValid;
  }

  public get baseURL() {
    return baseURL;
  }

  // info box
  public infoBoxDialogVisible = false;
  public infoBoxRow = null;

  // form
  public activeTab = 'customer';
  public activeSmsLimiterTab = '';
  public activeWhatsappLimiterTab = '';

  public get rules() {
    return {
      "account.username": [
        {
          required: true,
          trigger: "blur",
          message: this.$t('form["this field is required"]')
        }
      ],
      // "account.password": [
      //   {
      //     required: this.formState === 'create',
      //     trigger: "blur",
      //     message: this.$t('form["this field is required"]')
      //   }
      // ],
    };
  }

  public get formTitle() {
    switch (this.formState) {
      case "create":
        return this.$t('global["Create"]');
      case "edit":
        return this.$t('global["Edit"]');
      default:
        return "";
    }
  }
  public formState: string = "create";

  public formPage = 0;

  public form: any = null;

  public selectedServiceTypeSmss: number[] = [];
  public servicesRegions: {
    [serviceId: string]: string[] // region.name array
  } = {};

  public servicesRegionsCharges: {
    [serviceId: string]: {
        [regionId: string]: number
      }
    } = {};

  public subscriptionWhatsAppCharges: {
    [serviceTypeWhatsAppId: string]: {
      incoming: number,
      outgoing: number,
    }
  } = {};
  public resetSubscriptionWhatsAppCharges() {
    this.subscriptionWhatsAppCharges = {};

    for (const s of this.serviceTypeWhatsApps) {
      this.$set(this.subscriptionWhatsAppCharges, s.id, {
        incoming: 0,
        outgoing: 0,
      });
    }
  }

  // table filrer
  public username: string = null;
  public enabled: boolean = null;
  public orderByColumn: string = null;
  public orderByOrder: string = null;

  public get accountStates() {
    return [
      {
        label: 'enabled',
        key: true,
      },
      {
        label: 'disabled',
        key: false,
      },
    ]
  }

  // table
  public currentPage = 1;
  public pageSize = 100;
  public total = 0;

  public formVisible = false;
  public isTableLoading = false;
  public data: any[] = [];
  public regions: any[] = [];
  public services: any[] = [];
  public serviceTypeSmss: any[] = [];
  public serviceTypeWhatsApps: any[] = [];

  public vendors: any[] = [];
  public settings: any[] = [];

  public getService(id: number) {
    return this.services.find(p => p.id === +id) || {};
  }

  public getServiceTypeSms(id: number) {
    return this.serviceTypeSmss.find(p => p.id === +id) || {};
  }

  public hasService(serviceIds: number[], name: string) {
    if (Array.isArray(serviceIds)) {
      return serviceIds.some(id => this.getService(id).name === name);
    }

    return false;
  }

  public getSubscriptionSms(row: any) {
    const tagColors = {
      1: '',
      2: 'success',
      3: 'info',
      4: 'danger',
      5: 'warning',
    };

    return Enumerable.from(row.subscription.subscriptionSms.subscriptionSmsCharges as any[])
      .orderBy(p => p.serviceTypeSms.name)
      .select(p => ({
        text: `${p.serviceTypeSms.name} -> ${p.region.name}`,
        color: tagColors[p.serviceTypeSms.id],
      }))
      .toArray();
  }

  public mounted() {
    this.loadData();
  }

  // form
  public defaultForm(resetSubscription = true) {
    if (resetSubscription) {
      this.resetSubscriptionWhatsAppCharges();
    }

    return {
      enabled: true,
      account: {

      },
      customerNotificationAlerts: [],
      subscription: {
        subscriptionSms: {
          subscriptionSmsCharges: [],
          serviceTypeSmss: [],
          regions: [],
        },

        subscriptionWhatsApp: {
        }
      },
      smsLimiters: this.serviceTypeSmss.map((serviceTypeSms) => ({
        enabled: false,
        limit: 0,
        autoPause: false,
        pauseDurationMinute: 30,
        serviceTypeSms,
      })),
      whatsappLimiters: this.serviceTypeWhatsApps.map((serviceTypeWhatsApp) => ({
        enabled: false,
        limit: 0,
        autoPause: false,
        pauseDurationMinute: 30,
        serviceTypeWhatsApp,
      })),
    };
  }
  public onClickCreate() {
    this.formState = "create";
    this.activeTab = 'customer';
    this.resetForm();
    this.form = this.defaultForm();

    this.clearFormValidations();
    this.formVisible = true;
  }

  public async onEditClick(row: any) {
    const rowCopy = JSON.parse(JSON.stringify(row));

    const defaultForm = this.defaultForm(false);
    this.formState = "edit";
    this.activeTab = 'customer';
    this.resetForm();

    // notifications
    const customerNotificationAlerts = rowCopy.customerNotificationAlerts.map(p => {
      p.customerNotificationWalletAlertWallets = p.customerNotificationWalletAlertWallets.map(i => i.wallet.id);
      return p;
    })

    // subscription
    // TODO ts 3.7
    const subscriptionServices = rowCopy.subscription.services.map(p => p.id);

    // subscription sms
    if (rowCopy.subscription.subscriptionSms) {
      this.selectedServiceTypeSmss = Enumerable.from(rowCopy.subscription.subscriptionSms.subscriptionSmsCharges as any[])
        .select(p => p.serviceTypeSms.id)
        .distinct(p => p)
        .toArray();
      this.servicesRegions = Enumerable.from(rowCopy.subscription.subscriptionSms.subscriptionSmsCharges as any[])
        .groupBy(p => p.serviceTypeSms.id)
        .toObject(p => p.key(), p => p.toArray().map(p => p.region.name)) as any;
      this.servicesRegionsCharges = Enumerable.from(rowCopy.subscription.subscriptionSms.subscriptionSmsCharges as any[])
        .groupBy(p => p.serviceTypeSms.id)
        .toObject(p => p.key(), p => p.toObject(p => p.region.id, p => p.charge)) as any;
    }

    // subscription whats app
    this.resetSubscriptionWhatsAppCharges();

    let serviceTypeWhatsApps = null;
    if (rowCopy.subscription.subscriptionWhatsApp) {
      serviceTypeWhatsApps = rowCopy.subscription.subscriptionWhatsApp.serviceTypeWhatsApps.map((p => p.id));
      for (const s of rowCopy.subscription.subscriptionWhatsApp.subscriptionWhatsAppCharges || []) {
        this.$set(this.subscriptionWhatsAppCharges, s.serviceTypeWhatsApp.id, {
          incoming: s.incoming,
          outgoing: s.outgoing,
        });
      }
    }
    serviceTypeWhatsApps = serviceTypeWhatsApps && serviceTypeWhatsApps.length ? serviceTypeWhatsApps : [];

    const smsLimiters = defaultForm.smsLimiters.map((s) => {
      const l = row.smsLimiters || [];
      const found = l.find((o) => o.serviceTypeSms.id === s.serviceTypeSms.id);
      return found ? found : s;
    });

    const whatsappLimiters = defaultForm.whatsappLimiters.map((s) => {
      const l = row.whatsappLimiters || [];
      const found = l.find((o) => o.serviceTypeWhatsApp.id === s.serviceTypeWhatsApp.id);
      return found ? found : s;
    });

    // TODO ts 3.7
    const form = {
      ... row,
      // notification
      customerNotificationAlerts,
      // subscription
      subscription: {
        ... row.subscription || {},
        services: subscriptionServices,

        // whats app,
        subscriptionWhatsApp: {
          ... row.subscription.subscriptionWhatsApp || {},
          serviceTypeWhatsApps,
        },
      },
      smsLimiters,
      whatsappLimiters,
    };
    delete form.account.password;

    this.form = form;
    this.clearFormValidations();
    this.formVisible = true;
  }

  public async onEnabledClick(row, enabled = true) {
    this.onEditClick(row);
    this.formVisible = false;
    this.form.account.enabled = enabled;
    await this.onFormConfirm();
  }

  public async onClickResetSmsLimiterCount(id: number, customerId: number, name: string) {
    try {
      await this.$confirm(`Reload Page and Reset SMS Limit?`, 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        })
    } catch (e) {
      return;
    }

    try {
      await apiClient.postCustomerResetSmsLimiterCount(id);
      successNotify.bind(this)();
    } catch (e) {
      notifyErrorThrow.bind(this)(e);
    }

    await this.loadCustomers();
    const row = this.data.find((o) => o.id === customerId);
    if (row) {
      this.onEditClick(row);
    }
  }

  public async onClickResetWhatsappLimiterCount(id: number, customerId: number, name: string) {
    try {
      await this.$confirm(`Reload Page and Reset Whatsapp Limit?`, 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        })
    } catch (e) {
      return;
    }

    try {
      await apiClient.postCustomerResetWhatsappLimiterCount(id);
      successNotify.bind(this)();
    } catch (e) {
      notifyErrorThrow.bind(this)(e);
    }

    await this.loadCustomers();
    const row = this.data.find((o) => o.id === customerId);
    if (row) {
      this.onEditClick(row);
    }
  }

  public onFormCancel() {
    this.formVisible = false;
  }

  public async onFormConfirm() {
    if (this.formState === "create") {
      this.onCreateConfirm();
    } else {
      this.onEditConfirm();
    }
  }

  //
  public async onPaginationChange() {
    await this.loadData();
    this.$scrollTo("#data-table");
  }

  // sort
  public async tableSortChange({ column, prop, order }) {
    if (prop && order) {
      this.orderByColumn = camelcase(prop.replace('.', '_'));
      this.orderByOrder = order.startsWith("asc") ? "ASC" : 'DESC';
    } else {
      this.orderByOrder = this.orderByColumn = null;
    }
    return this.loadCustomers();
  }

  public onChangeServiceTypeSms(serviceIds) {
    const servicesRegions = {};
    const servicesRegionsCharges = {};

    for(const serviceId of serviceIds) {
      servicesRegions[serviceId] = this.servicesRegions[serviceId] || [];
      servicesRegionsCharges[serviceId] = this.servicesRegionsCharges[serviceId] || {};
    }

    this.servicesRegions = servicesRegions;
    this.servicesRegionsCharges = servicesRegionsCharges;
  }

  public async onAddCustomerNotificationEmail() {
    try {
      const { value } = await this.$prompt('Please input the email', '', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
          inputErrorMessage: 'Invalid Email'
        }) as any;

        if (this.form.customerNotificationAlerts.some(p => p.email === value.trim())) {
          return;
        }

        this.form.customerNotificationAlerts.push({
          email: value.trim(),
          walletAlert: false,
          walletReportUsage: false,
          walletReportTopUp: false,
          alertThreshold: this.settings.find(p => p.key === 'wallet.alert.threshold.default').value,
        });
    } catch (e) {
      console.error(e);
    }
  }

  private async onDeleteCustomerNotificationEmail(index) {
    const item = this.form.customerNotificationAlerts[index];
    await this.$confirm(`Delete email ${item.email}?`, 'Warning', {
      confirmButtonText: 'OK',
      cancelButtonText: 'Cancel',
      type: 'warning'
    });
    this.form.customerNotificationAlerts.splice(index, 1);
  }

  private onClickShowInfoBox(row: any) {
    this.infoBoxRow = row;
    this.infoBoxDialogVisible = true;
  }

  private onInfoBoxCancel() {
    this.infoBoxDialogVisible = false;
  }

  //
  private async loadData() {
    await Promise.all([
      this.loadCustomers(),
      this.loadRegions(),
      this.loadServices(),
      this.loadVendors(),
      this.loadSettings(),
    ]);
  }

  private async loadCustomers() {
    this.isTableLoading = true;
    const { data } = await apiClient.customers({
      take: this.pageSize,
      page: this.currentPage,

      orderByColumn: this.orderByColumn,
      orderByOrder: this.orderByOrder,

      username: this.username,
      enabled: this.enabled == null ? void 0 : this.enabled,
    });
    this.total = data.count;
    this.data = data.data;
    this.isTableLoading = false;
  }

  private async loadRegions() {
    const { data } = await apiClient.regions();
    this.regions = data;
  }

  private async loadServices() {
    const { data } = await apiClient.services();
    this.services = data;
    {
      const service = this.services.find(p => p.name === 'Sms') || {};
      this.serviceTypeSmss = service.serviceTypeSmss || [];
      this.activeSmsLimiterTab = this.serviceTypeSmss[0] ? this.serviceTypeSmss[0].name : '';
    }

    {
      const service = this.services.find(p => p.name === 'WhatsApp') || {};
      this.serviceTypeWhatsApps = service.serviceTypeWhatsApps || [];
      this.activeWhatsappLimiterTab = this.serviceTypeWhatsApps[0] ? this.serviceTypeWhatsApps[0].name : '';
    }
  }

  private async loadVendors() {
    const { data } = await apiClient.vendors();
    this.vendors = data;
  }

  private async loadSettings() {
    const { data } = await apiClient.settings();
    this.settings = data;
  }

  private async exportCustomers() {
    const loading = this.$loading({});
    try {
      const response = await apiClient.customersExport();
      download(response);
    } catch (e) {
      console.error(e);
      throw e;
    } finally {
      loading.close();
    }
  }

  // events
  private async onCreateConfirm() {
    try {
      await this.validateForm();
    } catch (e) {
      console.error(e);
      return;
    }

    const loading = this.$loading({});
    try {
      const { data } = await apiClient.postCustomers(this.getForm());
      this.formVisible = false;
      createNotify.bind(this)();
    } catch (e) {
      throw e;
    } finally {
      loading.close();
    }

    await this.loadData();
  }

  private async onEditConfirm() {
    try {
      await this.validateForm();
    } catch (e) {
      console.error(e);
      return;
    }

    const loading = this.$loading({});
    try {
      await apiClient.putCustomers(this.form.id, this.getForm());
      this.formVisible = false;
      updateNotify.bind(this)();
    } catch (e) {
      throw e;
    } finally {
      loading.close();
    }

    await this.loadData();
  }

  //
  private resetForm() {
    this.formPage = 0;
    this.servicesRegionsCharges = {};
    this.servicesRegions = {};
  }

  private getForm() {
    // notifications
    const alerts = JSON.parse(JSON.stringify(this.form.customerNotificationAlerts));
    const customerNotificationAlerts = alerts.map(p => ({
      ... p,
      customerNotificationWalletAlertWallets: p.customerNotificationWalletAlertWallets.map(id => ({
        wallet: {
          id,
        },
      })),
    }));

    // subscription
    const subscriptionServices = this.form.subscription.services.map(id => ({
      id,
    }));

    // subscription sms
    if (this.hasService(this.form.subscription.services, "Sms")) {
      var subscriptionSmsCharges = [];
      var subscriptionSmsRegions = Object.values(this.servicesRegions).map(regionName => this.regions.find(region => region.name === regionName));
      var subscriptionSmsServiceTypeSmss = this.selectedServiceTypeSmss.map(id => ({
        id,
      }));
      for(const [serviceTypeSmsId, regionNames] of Object.entries(this.servicesRegions)) {
        for(const regionName of regionNames) {
          const region = this.regions.find(region => region.name === regionName);
          subscriptionSmsCharges.push({
            serviceTypeSms: this.serviceTypeSmss.find(p => p.id === +serviceTypeSmsId),
            region,
            charge: this.servicesRegionsCharges[serviceTypeSmsId][region.id] || 0,
          });
        }
      }
    }

    // subscription whats app
    if (this.hasService(this.form.subscription.services, "WhatsApp")) {
      var serviceTypeWhatsApps = this.form.subscription.subscriptionWhatsApp.serviceTypeWhatsApps.map(id => ({
        id,
      }));
    }

    const subscriptionWhatsAppCharges = Object.entries(this.subscriptionWhatsAppCharges).map(([k, v]) => ({
      serviceTypeWhatsApp: {
        id: +k,
      },
      ... v,
    }));

    return {
      ... this.form,

      // customer alert
      customerNotificationAlerts,

      // subscription
      subscription: {
        ... this.form.subscription,
        services: subscriptionServices,

        // sms
        subscriptionSms: {
          ... this.form.subscription.subscriptionSms,
          regions: subscriptionSmsRegions,
          serviceTypeSmss: subscriptionSmsServiceTypeSmss,
          subscriptionSmsCharges,
        },

        // whats app,
        subscriptionWhatsApp: {
          ... this.form.subscription.subscriptionWhatsApp,
          serviceTypeWhatsApps,
          subscriptionWhatsAppCharges,
        },
      },
    };
  }

  private clearFormValidations() {
    if (this.$refs.form) {
      (this.$refs.form as any).clearValidate();
    }
  }

  private async validateForm() {
    await this.loadVendors();

    if (!this.form.account.username) {
      notifyErrorThrow.bind(this)("missing username");
    }

    if (this.form.account.email && !validator.isEmail(this.form.account.email)) {
      notifyErrorThrow.bind(this)("customer email format incorrect");
    }

    if (this.form.website && !validator.isURL(this.form.website)) {
      notifyErrorThrow.bind(this)("customer website url format incorrect");
    }

    // other validation
    if (this.formState === "create") {
      this.validateFormCreate();
    }

    this.validateSms();
    this.validateWhatsApp();
  }

  private async validateFormCreate() {
      if (!this.form.account.password) {
        // notifyErrorThrow.bind(this)("missing password");
      }
  }

  private async validateSms() {
    if (!this.hasService(this.form.subscription.services, 'Sms')) {
      return;
    }

    // check does there any vendor handle this service type
    for(const [serviceTypeSmsId, regionNames] of Object.entries(this.servicesRegions)) {
      for(const regionName of regionNames) {
        const region = this.regions.find(region => region.name === regionName);
        const vendor = this.vendors.find(p => p.vendorSmsServices.some(i => i.serviceTypeSms.id === +serviceTypeSmsId && i.region.id === region.id));
        if (!vendor) {
          const serviceTypeSms = this.serviceTypeSmss.find(p => p.id === +serviceTypeSmsId);
          const errorMessage = `No vendor able to handle service type '${serviceTypeSms.name}' of region: '${region.name}'`;
          try {
            await this.$confirm(`${errorMessage}. Are you sure to continue?`, 'Warning', {
              confirmButtonText: 'OK',
              cancelButtonText: 'Cancel',
              type: 'warning'
            });
          } catch (e) {
            notifyErrorThrow.bind(this)(errorMessage);
          }
        }
      }
    }
  }

  private async validateWhatsApp() {
    if (!this.hasService(this.form.subscription.services, 'WhatsApp')) {
      return;
    }
  }

}
